import types from '../types';
const {
  SET_GLOBAL_ERROR,
  SET_LOADING,
  SET_ERROR,
  SET_DONE,
  SET_ADMIN,
  SET_AUTH_ERROR,
  SET_FEEDBACK_SUCCESS,
} = types;

const globalReducer = (state, action) => {
  switch (action.type) {
    case SET_ADMIN:
      return {
        ...state,
        admin: action.payload,
      };
    case SET_GLOBAL_ERROR:
      return {
        ...state,
        globalError: action.payload,
      };
    case SET_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackSuccess: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_DONE:
      return {
        ...state,
        done: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_AUTH_ERROR:
      return {
        ...state,
        authError: action.payload,
      };
    default:
      return state;
  }
};

export default globalReducer;
